import { Icon } from "@iconify/react";
import { useState } from "react";
import ShareModal from "./ShareModal";
import { CommunityPost } from "../post/interfaces/post.interface";

type Props = {
  post?: CommunityPost;
  showText?: boolean;
  className?: string;
};

const ShareButton = ({ post, showText = true, className = "" }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Share post"
        className={`
          flex items-center gap-1 px-4 py-2 rounded-full
          hover:bg-charcoalGray/10 dark:hover:bg-deepSlate
          transition cursor-pointer
          focus:outline-none focus:ring-2 focus:ring-primary-500
          ${className}
        `}
      >
        <Icon icon="mdi:share-outline" className="w-5 h-5" />
        {showText && <span className="hidden sm:inline">Share</span>}
      </button>

      <ShareModal
        post={post}
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default ShareButton;